import { Link } from 'react-router';
import { Box, Container, Typography, Card, Button, Stack } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

export function ContactSection() {
  return (
    <Box sx={{ bgcolor: 'background.paper', py: { xs: 10, md: 14 } }}>
      <Container maxWidth="md">
        <Box>
            <Typography
              variant="h2"
              sx={{
                textAlign: 'center',
                mb: 3,
                fontSize: { xs: '2rem', md: '2.5rem' },
              }}
            >
              Kontakt
            </Typography>
            <Typography
              sx={{
                fontSize: '1.15rem',
                lineHeight: 1.8,
                mb: 7,
                textAlign: 'center',
                color: 'text.secondary',
                maxWidth: 600,
                mx: 'auto',
              }}
            >
              Pokud máte zájem o konzultaci nebo více informací, neváhejte mě kontaktovat.
              Ráda si s vámi domluvím schůzku.
            </Typography>

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={4}
              sx={{ mb: 7, justifyContent: 'center', alignItems: 'center' }}
            >
              {/* Telefon */}
              <Card
                sx={{
                  width: 300,
                  p: 4,
                  textAlign: 'center',
                  borderRadius: 3,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'inline-flex',
                    p: 2,
                    borderRadius: '50%',
                    bgcolor: 'primary.light',
                    mb: 2,
                  }}
                >
                  <PhoneIcon sx={{ fontSize: 32, color: 'primary.dark' }} />
                </Box>
                <Typography
                  variant="overline"
                  sx={{
                    fontSize: '0.85rem',
                    letterSpacing: '0.1em',
                    color: 'text.secondary',
                    fontWeight: 600,
                    display: 'block',
                    mb: 1.5,
                  }}
                >
                  Telefon
                </Typography>
                <Typography
                  component="a"
                  href="tel:+420797677397"
                  sx={{
                    fontSize: '1.35rem',
                    fontWeight: 500,
                    color: 'primary.dark',
                    textDecoration: 'none',
                    display: 'block',
                    transition: 'color 0.2s ease',
                    '&:hover': { color: 'text.primary' },
                  }}
                >
                  +420 797 677 397
                </Typography>
              </Card>

              {/* E-mail */}
              <Card
                sx={{
                  width: 300,
                  p: 4,
                  textAlign: 'center',
                  borderRadius: 3,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'inline-flex',
                    p: 2,
                    borderRadius: '50%',
                    bgcolor: 'secondary.light',
                    mb: 2,
                  }}
                >
                  <EmailIcon sx={{ fontSize: 32, color: 'secondary.dark' }} />
                </Box>
                <Typography
                  variant="overline"
                  sx={{
                    fontSize: '0.85rem',
                    letterSpacing: '0.1em',
                    color: 'text.secondary',
                    fontWeight: 600,
                    display: 'block',
                    mb: 1.5,
                  }}
                >
                  E-mail
                </Typography>
                <Typography
                  component="a"
                  href="mailto:hana.jarkovska@etoped.cz"
                  sx={{
                    fontSize: '1.15rem',
                    fontWeight: 500,
                    color: 'primary.dark',
                    textDecoration: 'none',
                    display: 'block',
                    transition: 'color 0.2s ease',
                    '&:hover': { color: 'text.primary' },
                  }}
                >
                  hana.jarkovska@etoped.cz
                </Typography>
              </Card>
            </Stack>

            {/* CTA Button */}
            <Box sx={{ textAlign: 'center' }}>
              <Button
                component={Link}
                to="/kontakt"
                variant="contained"
                size="large"
                sx={{
                  px: 6,
                  py: 2,
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  borderRadius: '6px',
                  textTransform: 'none',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                  '&:hover': {
                    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
                    transform: 'translateY(-2px)',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                Domluvit konzultaci
              </Button>
            </Box>
        </Box>
      </Container>
    </Box>
  );
}
